(ns practitest.frontend.forms3.entity-form.header
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.users :as users]
            [practitest.frontend.common-entities :as common-entities]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common-entities.metadata :as metadata]
            [practitest.frontend.components.grid.localstorage :as grid-local-storage]
            [practitest.frontend.components2.dropdown :as dropdown]
            [practitest.frontend.components2.entity-followers :refer [entity-followers]]
            [practitest.frontend.components2.pagination :as pagination]
            [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.forms3.entity-form.fields :as fields]
            [practitest.frontend.forms3.entity-form.forms :as forms]
            [practitest.frontend.forms3.entity-form.collab-events :as collab-events]
            [practitest.frontend.components2.tabs :as tabs]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]
            [practitest.frontend.common.keyboard-shortcuts :as keyboard-shortcuts]))

(defonce pending-entity-nav (reagent/atom nil))

(defn- new-entity-label [entity-type]
  (get-translation (str (name entity-type) ".new")
                   (str "New " (forms/entity->display-name entity-type))))

(defn- handle-pending-nav!
  [{:keys [entities current-page entity-type route]}]
  (when (and @pending-entity-nav
             (seq entities)
             (= current-page (:page @pending-entity-nav)))
    (let [{:keys [dir page]} @pending-entity-nav
          target-id (case dir
                      :next (:id (first entities))
                      :prev (:id (last entities)))
          {:keys [path-params query-params]} route
          id-key (keyword (str (name entity-type) "-id"))
          new-params (assoc path-params id-key (str target-id))
          route-name (get-in route [:data :name])]
      (reset! pending-entity-nav nil)
      (when target-id
        (re-frame/dispatch [::router/push-state route-name new-params query-params])))))

(defn render-pagination-button
  [{:keys [disabled? href on-click label]}]
  [:a.pagination-button
   {:href      (if disabled? "#" href)
    :class     ["pagination-button" (when disabled? "disabled")]
    :on-click  (fn [e]
                 (when disabled?
                   (.preventDefault e))
                 (when (and (not disabled?) on-click)
                   (on-click e)))}
   label])

(defn- render-back-next-navigation
  "Render 'Back' and 'Next' pagination buttons for a list of entities.
  Handles page switching, local storage updates, and entity list fetching when necessary."

  [{:keys [entity-type entities idx current-page total-count per-page total-pages
           session-key prev-id next-id grid-query state-key full-data? path-params]}]
    (let [loaded? (some? idx)
          first? (= idx 0)
          first-entity-of-page? (= (mod idx per-page) 0)
          last? (= idx (dec (count entities)))
          last-entity-of-page?  (= (mod (inc idx) per-page) 0)
          prev-page (dec current-page)
          next-page (inc current-page)
          current-page-calc (if full-data?
                              (inc idx)
                              (+ (* (dec current-page) per-page) (inc idx)))
          edit-route             (get-in metadata/entities-metadata
                                         [entity-type :urls :edit])
          prev-url               (when prev-id
                                   (broutes/get-url-view edit-route (merge path-params {:id prev-id})))
          next-url               (when next-id
                                   (broutes/get-url-view edit-route (merge path-params {:id next-id})))]
      [:div.pagination-control {:style {:margin-left "auto"}}
       [render-pagination-button
        {:disabled? (or
                      (not loaded?)
                      (and first? (= current-page 1)))
         :href (if (and first-entity-of-page? (> current-page 1) (not full-data?))
                 "#"
                 prev-url)
         :on-click (fn [e]
                     (when (and first-entity-of-page? (> current-page 1))
                       (.preventDefault e)
                       (grid-local-storage/save-current-page session-key prev-page)
                       (when-not full-data?
                         (reset! pending-entity-nav {:dir :prev :page prev-page})
                         (re-frame/dispatch [::common-events/fetch-entity-list
                                             entity-type
                                             state-key
                                             (assoc grid-query :page prev-page)]))))
         :label (get-translation "generic.button.back" "Back")}]

       [:div.pagination-info-span.with-spinner
        [icons/mux-chevron-left]
        (if loaded?
          [:span (str current-page-calc " of " total-count)]
          [spinners/mux-spinner {:size :small}])
        [icons/mux-chevron-right]]

       [render-pagination-button
        {:disabled? (or
                      (not loaded?)
                      (and last? (= current-page total-pages)))
         :href (if (and last-entity-of-page? (< current-page total-pages) (not full-data?))
                 "#"
                 next-url)
         :on-click (fn [e]
                     (when (and last-entity-of-page? (< current-page total-pages))
                       (.preventDefault e)
                       (grid-local-storage/save-current-page session-key next-page)
                       (when-not full-data?
                         (reset! pending-entity-nav {:dir :next :page next-page})
                         (re-frame/dispatch [::common-events/fetch-entity-list
                                             entity-type
                                             state-key
                                             (assoc grid-query :page next-page)]))))
         :label (get-translation "generic.button.next" "Next")}]]))

(defn breadcrumbs-view [{:keys [breadcrumbs
                                entity-type
                                base-entity
                                last-breadcrumb-fn
                                path-params
                                new?
                                section
                                entities
                                total-count
                                current-page
                                per-page
                                full-data?
                                right-section
                                on-back]
                         :as props}]
  (let [last-breadcrumb-fn (or last-breadcrumb-fn
                               (fn []
                                 (if new?
                                   (new-entity-label entity-type)
                                   (str (get-translation
                                          (str (name entity-type) ".singular")
                                          (forms/entity->display-name entity-type)) " #" (:display_id base-entity)))))]
    [:div.breadcrumbs-container
     [:a.breadcrumbs-back
      {:on-click (or on-back #(js/history.back))}
      [icons/mux-arrow-left3]]
     (for [item breadcrumbs]
       [:<>
        {:key (:href item)}
        [:a.breadcrumbs-item
         (cond-> {:href (:href item)}
           (:on-click item) (assoc :on-click (:on-click item)))
         (:label item)]
        [:span.breadcrumbs-delimiter
         [icons/mux-chevron-right]]])
     [:span
      (when (and entity-type base-entity)
        (last-breadcrumb-fn props))
      (when section
        section)]
     (when (and (not new?)
                (not= entity-type :milestone)
                (seq entities))
       (let [current-id    (:id base-entity)
             project-id    (:id @(re-frame/subscribe [::subs/current-project]))
             table-id      (get-in metadata/entities-metadata [entity-type :table-id])
             session-key   (str project-id "-" table-id)
             idx           (common-entities/get-entity-index entities current-id)
             total-pages   (pagination/get-total-pages total-count per-page)
             prev-entity   (when (pos? idx)       (nth entities (dec idx)))
             next-entity   (when (< idx (dec (count entities))) (nth entities (inc idx)))
             prev-id       (:id prev-entity)
             next-id       (:id next-entity)
             grid-query    (common-entities/build-grid-query session-key per-page current-page)
             state-key     (subs/index-grid-keys entity-type)
             route         @(re-frame/subscribe [::router/current-route])]

         (handle-pending-nav! {:entities entities
                               :current-page current-page
                               :entity-type entity-type
                               :route route})

         [render-back-next-navigation
          {:entity-type  entity-type
           :entities     entities
           :idx          idx
           :current-page current-page
           :total-count  total-count
           :per-page     per-page
           :total-pages  total-pages
           :session-key  session-key
           :prev-id      prev-id
           :next-id      next-id
           :grid-query   grid-query
           :state-key    state-key
           :path-params  path-params
           :full-data?   full-data?}]))
     (when right-section
       [right-section])]))

(defn active-tab-from-fragment [] (some-> (router/get-current-fragment-decoded) :tab keyword))

(defn set-active-tab
  ([form-props tab]
   (set-active-tab form-props tab nil))
  ([form-props tab history-filter]
   (cond
     (= tab :traceability)
     (mixpanel/track "Form Actions" {"Action" "Enter Traceability Tab"})

     (= tab :history)
     (mixpanel/track "Form Actions" {"Action" "Enter History Tab"})

     (= tab :linked-issues)
     (mixpanel/track "Forms Actions" {"Action" "View Linked Issues"}))

   (router/update-fragment! assoc :tab tab)
   (swap! (:main-state form-props) assoc :form-active-tab tab)
   (when (= tab :history)
     (re-frame/dispatch [:practitest.frontend.common-entities.events/set-history-filter history-filter]))))

;; Special component to handle keyboard shortcut navigation for tabs
(defn- tabs-keyboard-shortcuts-component
  [form-props]
  (let [current-props (atom nil)
        shortcut-handler (fn [event-id]
                           (let [{:keys [active-tab-id]
                                         tabs :header-tabs } @current-props
                                 not-current-tab-fn (fn [tab]
                                                      (not= (:tab-id tab) active-tab-id))
                                 new-tab (case event-id
                                           "next-tab"
                                           (->> tabs
                                                   ;; Using `cycle` here to go over the last tab
                                                (cycle)
                                                (drop-while not-current-tab-fn)
                                                (fnext))

                                           "prev-tab"
                                              ;; Special case for 1st tab selected
                                           (if (= active-tab-id (:tab-id (first tabs)))
                                                ;; Go to last tab in this case
                                             (last tabs)
                                                ;; Otherwise select previous one
                                             (last (take-while not-current-tab-fn tabs)))

                                              ;; ignore everything else
                                           nil)]
                             (when new-tab
                               (set-active-tab form-props (:tab-id new-tab)))))]
    (reset! current-props form-props)
    [:<>
     [keyboard-shortcuts/add-shortcut {:shortcut [:entity-form :next-tab]
                                       :handler (fn [] (shortcut-handler "next-tab"))}]
     [keyboard-shortcuts/add-shortcut {:shortcut [:entity-form :prev-tab]
                                       :handler (fn [] (shortcut-handler "prev-tab"))}]]))

(defn- header-tabs-view [{:keys [form-id
                     entity-id
                     header-tabs] :as form-props} active-tab]
  [:<>
   ;; we expect that only one entity-form will be active at the same time
   [tabs-keyboard-shortcuts-component (assoc form-props :active-tab-id active-tab)]
   (into
     [tabs/tabs-container {:on-toggle (fn [tab-id] (set-active-tab form-props tab-id))
                           :shortcuts? true
                           :active-tab-id active-tab}]
  
     (for [tab (remove nil? header-tabs)]
       [tabs/tab {:tab-id (:tab-id tab) :header? true}
         (:tab-title tab)]))])

(defn form-collab-section [_]
  (let [number-of-visible-users 2]
    (fn [form-id]
        (let [current-path (.-pathname js/window.location)
              all-online-users @(re-frame/subscribe [::subs/online-users])
              editing-colors @(re-frame/subscribe [::collab-events/all-editing-users-colors form-id])
              online-users (->> (vals all-online-users)
                                 (filter
                                   (fn [{:keys [location]}]
                                       (some #(= current-path (.-pathname (js/URL. %)))
                                             (if (set? location) location #{location})))))
              users-count (count (vals online-users))]
      (when online-users
        [:div#online-users
         (doall
           (for [{:keys [id state]} (take number-of-visible-users online-users)]
            (let [user (users/find-user @(re-frame/subscribe [::subs/users]) id)
                  user-color (get editing-colors id)]
              ^{:key id}
              [:div.online-user
               [users/user-collab-avatar user state user-color]])))
          (when (pos? (- users-count number-of-visible-users))
            ^{:key "remaining-users"}
            [:span.remaining-users
             (str "+ " (- users-count number-of-visible-users))])])))))

(defn- _form-header [{:keys [expanded?
                             breadcrumbs
                             last-breadcrumb-fn
                             path-params
                             entity-type
                             data-entity-type
                             additional-header-buttons
                             main-ref
                             inputs-refs
                             new?
                             field-edit-permissions?
                             edit-permissions?
                             edit-locked?
                             use-test-workflow?
                             entity-name-renderer
                             form-id
                             popup-menu
                             base-entity] :as form-props} active-tab
                   {:keys [entities total-count current-page per-page full-data?]}]
  (let [can-edit? (and edit-permissions? (not edit-locked?))
        edit-name-ref (:edit-name-ref inputs-refs)
        edit-focus-handler (fn [] (dom/focus-on-ref! edit-name-ref false))
        snapshot? (false? (:current base-entity))]
    [:div.form-header
     {:class (dom/classes-pairs-v :collapsed expanded?)} 
     [keyboard-shortcuts/add-shortcut {:shortcut [:entity-form :edit-name ]
                                       :handler edit-focus-handler}]
     (when-not expanded?
       [breadcrumbs-view
        {:breadcrumbs breadcrumbs
         :last-breadcrumb-fn last-breadcrumb-fn
         :path-params path-params
         :data-entity-type data-entity-type
         :entity-type entity-type
         :base-entity base-entity
         :new? new?
         :entities entities
         :total-count total-count
         :current-page current-page
         :per-page per-page
         :full-data? full-data?
         :right-section (:breadcrumbs-right form-props)
         :on-back (:on-back form-props)}])

     (when-let [custom-banner (:custom-banner form-props)]
       [custom-banner])

                 ;; TODO: technically it's part of entity form
    [:<>
      [:div.header-container
       (when edit-locked?
         [:span.lock-icon
          [icons/lock]])
       (if entity-name-renderer
         [entity-name-renderer form-props]
         [:span.entity-name (if new?
                              (str (new-entity-label entity-type) "-")
                              (str (get-translation
                                     (str (name entity-type) ".singular")
                                     (forms/entity->display-name entity-type)) " #" (:display_id base-entity)))])
       (if-let [name-fn (:header-name-fn form-props)]
         [name-fn form-props]
         [fields/build-field
          {:field-name        :name
           :edit-permissions? (if (:external_id base-entity)
                                false
                                (get field-edit-permissions? :name edit-permissions?))
           :edit-locked? edit-locked?
           :use-test-workflow? use-test-workflow?
           :ref edit-name-ref}
          form-props])

       (when (some? additional-header-buttons)
         [additional-header-buttons form-props])

       (when (and (not new?)
                  (not snapshot?)
                  (get-in metadata/entities-metadata [entity-type :has-followers?]))
        [entity-followers (:followers base-entity) entity-type])

      (when (not new?)
        (let [entity-form-id (str (name form-id) "-" (:id base-entity))]
          [form-collab-section entity-form-id]))

       (when (and (not new?) (seq popup-menu))
        [dropdown/dropdown-menu
         (fn [{:keys [toggle!]}]
           [:button.more-button
            {:class (when-not can-edit? " disabled")
             :on-click (when can-edit?
                         toggle!)}
            [icons/mux-three-dots]])
             ;; overlay props
         {:placement "bottom-end"
          ;; We want whole entity form screen to be parent container for dropdown,
          ;; otherwise there can be annoying issues with overlapping and z-index
          :container main-ref}
         [dropdown/dropdown-menu-body
              ;; TODO: replace with class
          {:style {:width "max-content"
                   :min-width "233px"}}
          (for [item popup-menu]
            (when item
              ^{:key (:text item)} [dropdown/dropdown-menu-item item]))]])]

       (when (and new? (= entity-type :test))
         [fields/build-test-type-field
          {:field-name        :test_type
           :edit-permissions? true
           :set-active-tab-fn (fn [tab-id] (set-active-tab form-props tab-id))}
          form-props])]

     (when-not expanded?
       [header-tabs-view form-props active-tab])]))

(defn form-header [_form-props _active-tab _pagination-props]
  (let [edit-name-ref (atom nil)
        inputs-refs {:edit-name-ref edit-name-ref}]
    (reagent/create-class
     {:component-did-mount (fn []
                             (let [query-params (router/get-current-query-params)
                                   should-focus? (= (:should-focus query-params) "true")]
                               (when should-focus? (dom/focus-on-ref! edit-name-ref true))))
      :reagent-render (fn [form-props active-tab pagination-props]
                        [_form-header (assoc form-props :inputs-refs inputs-refs) active-tab pagination-props])})))
